//eslint-disable-next-line
export const myPagesStore = (axiosInstance, mocks, mockdb, apiUrl, addNotification) => {
  return {
    getters: {
      getOptInOutInformation(state) {
        return state.optInOutInformation
      },
      getInvoiceSettingsData(state) {
        return state.invoiceSettingsData
      },
      getInvoiceSendMethodData(state) {
        return state.invoiceSendMethodData
      }
    },
    actions: {
      async searchAddress(context, payload) {
        mocks.mockData(`${apiUrl.getSearchAddress.replace('{address}', payload.inputText)}`, 5, 'getSearchAddresses')
        const response = axiosInstance.get(`${apiUrl.getSearchAddress.replace('{address}', payload.inputText)}`)
        if (response.status === 200) addNotification(context, response)

        return response
      },
      async fetchOptInOutInformation(context) {
        mocks.mockData(`${apiUrl.getOptInOutInformation}`, mockdb.randomNumber(200, 500), 'getOptInOutInformation')
        const response = await axiosInstance.get(`${apiUrl.getOptInOutInformation}`)
        if (response.status === 200) context.commit('updateOptInOutInformation', response.data.data.communicationTypeList)
        return response
      },
      async putOptInOutInformation(context, payload) {
        mocks.mockPut(apiUrl.putOptInOutInformation, payload, mockdb.randomNumber(300, 1000), 'putOptInOutInformation')
        const response = await axiosInstance.put(`${apiUrl.putOptInOutInformation}`, payload)

        if (response.status === 200) addNotification(context, response)

        return response
      },
      async fetchDeliverySiteInformation(context, activeDeliverySiteId) {
        const extraParams1 = context.state.myPagesCorporate && context.state.activeCustomerId ? `?customerId=${context.state.activeCustomerId}` : ''

        mocks.mockData(`${apiUrl.getDeliverySiteInformation}${activeDeliverySiteId}${extraParams1}`, mockdb.randomNumber(200, 2000), 'getDeliverySiteInformation')
        const response = await axiosInstance.get(`${apiUrl.getDeliverySiteInformation}${activeDeliverySiteId}${extraParams1}`)

        if (response.status === 200) context.commit('updateDeliverySiteInformation', response.data.data)

        return response
      },
      async fetchOverviewInvoiceData(context, payload) {
        mocks.mockData(apiUrl.getOverviewInvoiceData, 2000, 'getOverviewInvoiceData')
        const response = await axiosInstance.get(apiUrl.getOverviewInvoiceData)

        if (response.status === 200) context.commit('updateOverviewInvoiceData', { status: response.status, response: response.data, type: payload, reset: payload.reset })

        return response
      },
      async fetchOverviewPowerOutageData(context, payload) {
        mocks.mockData(apiUrl.getOverviewPowerOutageData, 2000, 'getOverviewPowerOutageData')
        const response = await axiosInstance.get(apiUrl.getOverviewPowerOutageData)

        if (response.status === 200) context.commit('updateOverviewPowerOutageData', { status: response.status, response: response.data, type: payload, reset: payload.reset })

        return response
      },
      fetchConsumptionChartDataDefault(context, payload) {
        const isFutureOrHistoricalDeliverySite = payload.customerStatus === 'Future' || payload.customerStatus === 'Historical'
        const direction = payload.isConsumptionSite === undefined ? '' : payload.isConsumptionSite ? 'Consumption' : 'Production'
        const extraParams1 = context.state.myPagesCorporate && context.state.activeCustomerId ? `?customerId=${context.state.activeCustomerId}` : ''
        const extraParams2 =
          context.state.myPagesCorporate && (context.state.activeDeliverySiteId === 'all' || context.state.activeDeliverySiteId?.includes('group/') || payload.isConsumptionSite !== undefined)
            ? `&direction=${payload.isConsumptionSite === undefined ? context.state.chartDirection : direction}`
            : ''
        const extraParams3 = context.state.myPagesCorporate && context.state.tabValue === 'Reaktiv' ? `&isReactive=true` : ''
        const extraParams4 = payload.isPowerTariff ? '?isPowerTariff=true' : ''
        const extraParams5 = isFutureOrHistoricalDeliverySite ? '?isfutureorhistoricaldeliverysite=true' : ''

        const requestUrl = `${apiUrl.getConsumptionChartData}default/${payload.id === undefined ? payload : payload.id}${extraParams1}${extraParams2}${extraParams3}${extraParams4}${extraParams5}`

        return axiosInstance.get(requestUrl)

        // mocks.mockConsumptionChartDataDefault(requestUrl, 1000, 'getConsumptionChartData')
      },
      fetchConsumptionChartData(context, payload) {
        const encodedFrom = encodeURIComponent(payload.from)
        const encodedTo = encodeURIComponent(payload.to)
        const extraParams = context.state.myPagesCorporate && context.state.activeCustomerId ? `&customerId=${context.state.activeCustomerId}` : ''
        const extraParams2 = context.state.myPagesCorporate && context.state.tabValue === 'Reaktiv' ? `&isReactive=true` : ''

        // mocks.mockConsumptionChartData(requestUrl, 1000, 'getConsumptionChartWithErrors')

        if (payload.dateRanges && payload.dateRanges.length > 0) {
          const rangePromiseArray = payload.dateRanges.map((range) => {
            const requestUrl = `${apiUrl.getConsumptionChartData}${payload.id}?from=${range.from}&to=${range.to}&resolution=Monthly&direction=consumption`
            return axiosInstance.get(requestUrl)
          })

          return rangePromiseArray
        } else {
          const requestUrl = `${apiUrl.getConsumptionChartData}${payload.id}?from=${encodedFrom}&to=${encodedTo}&resolution=${payload.resolution}${extraParams}${extraParams2}`
          return axiosInstance.get(requestUrl)
        }
      },
      async fetchConsumptionChartDataNoCache(context, payload) {
        const encodedFrom = encodeURIComponent(payload.from)
        const encodedTo = encodeURIComponent(payload.to)
        const compare = payload.compare ? payload.compare.toString().replace('0', '').replace('1', '&comparePrevious=true').replace('2', '&comparePreviousYear=true') : ''

        const extraParams1 = context.state.myPagesCorporate && context.state.activeCustomerId ? `&customerId=${context.state.activeCustomerId}` : ''
        const extraParams2 = context.state.myPagesCorporate && (context.state.activeDeliverySiteId === 'all' || context.state.activeDeliverySiteId?.includes('group/')) ? `&direction=${context.state.chartDirection}` : ''
        const extraParams3 = context.state.myPagesCorporate && context.state.tabValue === 'Reaktiv' ? `&isReactive=true` : ''
        const requestUrl = `${apiUrl.getConsumptionChartData}${payload.id}?from=${encodedFrom}&to=${encodedTo}&resolution=${payload.resolution}&previous=${payload.previous}&next=${payload.next}&interval=${payload.interval}${compare}${extraParams1}${extraParams2}${extraParams3}`

        mocks.mockConsumptionChartDataGenerated(requestUrl, 1000)
        const response = await axiosInstance.get(requestUrl)
        if (response.status !== 200) addNotification(context, response)
        return response
      },
      async fetchConsumptionChartDataForOverview(context, payload) {
        const encodedFrom = encodeURIComponent(payload.from)
        const encodedTo = encodeURIComponent(payload.to)
        const extraParams1 = context.state.myPagesCorporate && context.state.activeCustomerId ? `&customerId=${context.state.activeCustomerId}` : ''
        const extraParams2 = '&direction=consumption'
        const requestUrl = `${apiUrl.getConsumptionChartData}all?from=${encodedFrom}&to=${encodedTo}&resolution=Monthly${extraParams1}${extraParams2}`

        mocks.mockConsumptionChartDataGenerated(requestUrl, 1000)
        const response = await axiosInstance.get(requestUrl)
        if (response.status !== 200) addNotification(context, response)
        return response
      },
      async fetchPriceSupportDataForOverview() {
        const response = await axiosInstance.get(apiUrl.getPriceSupportData)
        return response
      },
      fetchEffectChartDataNoCache(context, payload) {
        const encodedFrom = encodeURIComponent(payload.from)
        const encodedTo = encodeURIComponent(payload.to)
        mocks.mockEffectChartDataGenerated(`${apiUrl.getEffectChartData.replace('{id}', payload.id)}?from=${encodedFrom}&to=${encodedTo}&resolution=${payload.resolution}&interval=${payload.interval}`, 2000)
        return axiosInstance.get(`${apiUrl.getEffectChartData.replace('{id}', payload.id)}?from=${encodedFrom}&to=${encodedTo}&resolution=${payload.resolution}&interval=${payload.interval}`)
      },
      async fetchTemperatureChartDataNoCache(context, payload) {
        const encodedFrom = encodeURIComponent(payload.from)
        const encodedTo = encodeURIComponent(payload.to)
        const extraParams = context.state.myPagesCorporate && context.state.activeCustomerId ? `&customerId=${context.state.activeCustomerId}` : ''

        mocks.mockTemperatureChartDataGenerated(`${apiUrl.getTemperatureChartData}${payload.id}?from=${encodedFrom}&to=${encodedTo}&resolution=${payload.resolution}&interval=${payload.interval}${extraParams}`, 3000)
        const response = await axiosInstance.get(`${apiUrl.getTemperatureChartData}${payload.id}?from=${encodedFrom}&to=${encodedTo}&resolution=${payload.resolution}&interval=${payload.interval}${extraParams}`)
        if (response.status !== 200) addNotification(context, response)
        return response
      },
      resetConsumptionChartData(context) {
        context.commit('resetConsumptionChartData')
      },
      async fetchMeterReadingsData(context, payload) {
        const extraParams = context.state.myPagesCorporate && context.state.activeCustomerId ? `&customerId=${context.state.activeCustomerId}` : ''
        mocks.mockData(`${apiUrl.getMeterReadingsData.replace('{id}', payload.id)}${payload.params}${extraParams}`, 2000, 'getMeterReadingsData')
        const response = await axiosInstance.get(`${apiUrl.getMeterReadingsData.replace('{id}', payload.id)}${payload.params}${extraParams}`)
        context.commit('updateMeterReadingsData', { response: response.data, type: payload, reset: payload.reset })
        return response
      },
      async fetchTableAccessibleMockData() {
        mocks.mockData(`${apiUrl.getTableAccessibleMockData}`, 2000, 'getTableAccessibleMockData')
        const response = await axiosInstance.get(`${apiUrl.getTableAccessibleMockData}`)

        return response
      },
      updateInvoiceSettingsData(context, payload) {
        context.commit('updateInvoiceSettingsData', { response: payload.data })
      },
      async fetchInvoiceSettingsData(context, payload) {
        mocks.mockData(apiUrl.getInvoiceSettingsData.replace('{id}', payload), mockdb.randomNumber(500, 3000), 'getInvoiceSettingsData')
        const response = await axiosInstance.get(apiUrl.getInvoiceSettingsData.replace('{id}', payload))

        if (response.status === 200) context.commit('updateInvoiceSettingsData', { response: response.data, type: payload })

        return response
      },
      async fetchInvoiceSendMethodData(context, payload) {
        mocks.mockData(apiUrl.getInvoiceSendMethodData.replace('{id}', payload), mockdb.randomNumber(500, 3000), 'getInvoiceSendMethodData')
        const response = await axiosInstance.get(apiUrl.getInvoiceSendMethodData.replace('{id}', payload))

        if (response.status === 200) context.commit('updateInvoiceSendMethodData', { response: response.data, type: payload })

        return response
      },
      async postInvoiceSendMethodEInvoice(context, payload) {
        const response = await axiosInstance.post(apiUrl.postInvoiceSendMethodDataEInvoice, payload)
        addNotification(context, response)
        return response
      },
      async postInvoiceSendMethodEmail(context, payload) {
        const response = await axiosInstance.post(apiUrl.postInvoiceSendMethodEmail, payload)
        addNotification(context, response)
        return response
      },
      async postInvoiceSendMethodPostal(context, payload) {
        const response = await axiosInstance.post(apiUrl.postInvoiceSendMethodPostal, payload)
        addNotification(context, response)
        return response
      },
      async postInvoiceSettingsData(context, payload) {
        mocks.mockPost(apiUrl.getInvoiceSettingsData.replace('{id}', payload.deliverySiteId), payload.address, mockdb.randomNumber(1500, 2000), 'postInvoiceSettingsData')
        const response = await axiosInstance.post(apiUrl.getInvoiceSettingsData.replace('{id}', payload.deliverySiteId), payload.address)

        addNotification(context, response)

        return response
      },

      async postActivateAutogiro(_, payload) {
        const response = await axiosInstance.post(apiUrl.postActivateAutogiro, payload)

        //addNotification(context, response)

        return response
      },
      async postPollAutogiro(_, payload) {
        const response = await axiosInstance.post(apiUrl.postPollAutogiro, payload)

        //addNotification(context, response)

        return response
      },
      async postSignAutogiro(_, payload) {
        const response = await axiosInstance.post(apiUrl.postSignAutogiro, payload)
        return response
      },
      async getInitBankId(_, payload) {
        const extraParams = `?bankAccountNumber=${payload.bankAccountNumber}`
        const response = await axiosInstance.get(apiUrl.getInitBankId + extraParams)
        return response
      },
      async getQrImageBankId(_, payload) {
        const refId = payload.refId
        const transactionId = payload.transactionId
        const extraParams = `?refId=${refId}&transactionId=${transactionId}`
        const response = await axiosInstance.get(apiUrl.getQrImageBankId + extraParams)

        return response
      },
      async getCancelBankId(_, payload) {
        const extraParams = `?refId=${payload.refId}&transactionId=${payload.transactionId}`
        const response = await axiosInstance.get(apiUrl.getCancelBankId + extraParams)
        return response
      },
      async deleteRemoveAutogiro(context, payload) {
        const response = await axiosInstance.delete(apiUrl.deleteRemoveAutogiro.replace('{id}', payload))

        if (response.status === 200) context.commit('updateInvoiceSendMethodData', { response: response.data, type: payload })
        //addNotification(context, response)

        return response
      },

      async fetchAccountSettingsEmailData(context) {
        mocks.mockData(`${apiUrl.getAccountSettingsEmailData}`, mockdb.randomNumber(200, 2000), 'getAccountSettingsEmailData')
        const response = await axiosInstance.get(`${apiUrl.getAccountSettingsEmailData}`)

        if (response.status === 200) context.commit('updateAccountSettingsEmailData', response.data.data)

        return response
      },
      async fetchPowerOutageNotificationsData(context, id) {
        mocks.mockData(`${apiUrl.getPowerOutageNotificationsData}${id}`, mockdb.randomNumber(500, 3000), 'getPowerOutageNotificationsData')
        const response = await axiosInstance.get(`${apiUrl.getPowerOutageNotificationsData}${id}`)

        if (response.status === 200) context.commit('updatePowerOutageNotificationsData', response.data.data)

        return response
      },
      async fetchCustomerDetails(context, id) {
        const url = `${apiUrl.getCustomerDetails}`
        const urlCorporate = `${apiUrl.getCustomerDetails}?customerId=${id}`
        mocks.mockData(id !== '' ? urlCorporate : url, mockdb.randomNumber(200, 2000), 'getCustomerDetails')
        const response = await axiosInstance.get(id !== '' ? urlCorporate : url)

        if (response.status === 200) context.commit('updateCustomerDetails', response.data.data)

        return response
      },
      async fetchContactDetails(context, id) {
        const url = `${apiUrl.getContactDetails}`
        const urlCorporate = `${apiUrl.getContactDetails}?customerId=${id}`
        mocks.mockData(id !== '' ? urlCorporate : url, mockdb.randomNumber(200, 2000), 'getContactDetails')
        const response = await axiosInstance.get(id !== '' ? urlCorporate : url)

        if (response.status === 200) context.commit('updateContactDetails', response.data.data)

        return response
      },
      async putContactInformationConfirmation(context, payload) {
        const params = new URLSearchParams(payload)
        const url = `${apiUrl.putContactInformationConfirmation}${params != null ? `?${params.toString()}` : ''}`
        mocks.mockPut(url, mockdb.randomNumber(300, 1000), 'putContactInformationConfirmation')
        const response = await axiosInstance.put(`${url}`)

        if (response.status === 200) addNotification(context, response)

        return response
      },
      async fetchPriceCalculationData(_, payload) {
        const uri = payload.isFutureDeliverySite ? `${apiUrl.getPriceCalculationData}${payload.id}?period=${payload.period}&isfuturedeliverysite=true` : `${apiUrl.getPriceCalculationData}${payload.id}?period=${payload.period}`

        mocks.mockData(uri, 1000, 'getPriceCalculationData')
        return await axiosInstance.get(uri)
      },
      async fetchEffectPriceCalculations(context, payload) {
        const params = new URLSearchParams(payload)
        params.delete('id')

        const url = `${apiUrl.getEffectPriceCalculationData}${payload.id}?${params.toString()}&period=0`

        mocks.mockData(url, mockdb.randomNumber(1000, 3000), 'getEffectPriceCalculationData')

        const response = await axiosInstance.get(url, payload)
        return response
      },
      async getPowerTariffCostComparison(_, payload) {
        const params = payload.apiParams

        let url = `${apiUrl.getPowerTariffCostComparison}${params ? '?' + params.toString() : ''}`
        url = url.replace('{id}', payload.id)

        const response = await axiosInstance.get(url, payload)
        return response
      },
      deleteUserAccount(_, payload) {
        mocks.mockPost(apiUrl.deleteUserAccount, payload, mockdb.randomNumber(3000, 5000), 'deleteUserAccount')
        return axiosInstance.post(apiUrl.deleteUserAccount)
      },
      async addAccount(context, payload) {
        mocks.mockPost(apiUrl.addAccount, payload, 2000, 'addAccount')
        const response = await axiosInstance.post(apiUrl.addAccount, payload)

        if (response.status === 200 && response.data.data !== null) {
          context.commit('updateCustomers', response.data.data)
          context.commit('updateActiveCustomerId', response.data.data[0].customerNumber)
        }

        if (!payload.checkSignatory) {
          addNotification(context, response)
        }
        return response
      },
      async removeAccount(context, payload) {
        mocks.mockPost(apiUrl.removeAccount, payload, 200, 'removeAccount')
        const response = await axiosInstance.post(apiUrl.removeAccount, payload)

        if (response.status === 200 && response.data.data !== null) {
          context.commit('updateCustomers', response.data.data)
          context.commit('updateActiveCustomerId', response.data.data[0].customerNumber)
        }

        addNotification(context, response)
        return response
      },
      async postPowerOutageNotifications(context, payload) {
        mocks.mockPost(apiUrl.postPowerOutageNotifications, payload, mockdb.randomNumber(1000, 3000), 'postPowerOutageNotifications')
        const response = await axiosInstance.post(`${apiUrl.postPowerOutageNotifications}`, payload)

        if (response.status === 200) context.commit('updatePowerOutageNotificationsData', response.data.data)

        addNotification(context, response)
        return response
      },
      async postAccountSettingsEmail(context, payload) {
        mocks.mockPost(apiUrl.postAccountSettingsEmail, payload, mockdb.randomNumber(1000, 3000), 'postAccountSettingsEmail')
        const response = await axiosInstance.post(`${apiUrl.postAccountSettingsEmail}`, payload)

        if (response.status === 200) context.commit('updateAccountSettingsEmailData', response.data.data)
        addNotification(context, response)

        return response
      },
      async postAccountSettingsPassword(context, payload) {
        mocks.mockPost(apiUrl.postAccountSettingsPassword, payload, mockdb.randomNumber(1000, 3000), 'postAccountSettingsPassword')
        const response = await axiosInstance.post(`${apiUrl.postAccountSettingsPassword}`, payload)

        addNotification(context, response)

        return response
      },
      async postContactDetails(context, payload) {
        const id = payload.id || ''
        if (payload.id) {
          delete payload.id
        }
        const url = `${apiUrl.postContactDetails}`
        const urlCorporate = `${apiUrl.postContactDetails}?customerId=${id}`

        mocks.mockPost(id !== '' ? urlCorporate : url, payload, mockdb.randomNumber(200, 2000), 'postContactDetails')
        const response = await axiosInstance.post(id !== '' ? urlCorporate : url, payload)

        if (response.status === 200) context.commit('updateContactDetails', response.data.data)
        addNotification(context, response)

        return response
      },
      async fetchCreditPaymentsTableData(context, payload) {
        const extraParams = context.state.myPagesCorporate && context.state.activeCustomerId ? `&customerId=${context.state.activeCustomerId}` : ''
        const requestUrl = `${apiUrl.getCreditPaymentsTableData.replace('{id}', payload.id)}${payload.params}${extraParams}`

        mocks.mockData(requestUrl, 2000, 'getCreditPaymentsTableData')
        const response = await axiosInstance.get(requestUrl)
        context.commit('updateCreditPaymentsData', { status: response.status, response: response.data, type: payload, reset: payload.reset })
        return response
      },
      async fetchPossiblePayoutsData(context) {
        const requestUrl = apiUrl.getPossiblePayoutsData

        mocks.mockData(requestUrl, 2000, 'getPossiblePayoutsData')
        const response = await axiosInstance.get(requestUrl)

        context.commit('updatePossiblePayoutsData', response.data.data)

        return response
      },
      async postPossiblePayouts(context, payload) {
        const requestUrl = apiUrl.postPossiblePayouts
        mocks.mockPost(requestUrl, payload, mockdb.randomNumber(200, 2000), 'postPossiblePayouts')
        const response = await axiosInstance.post(requestUrl, payload)

        if (response.status === 200) context.commit('updatePossiblePayoutsData', response.data.data)
        // else addNotification(context, response)

        return response
      },
      async fetchBankAccountDetailsData(context) {
        const requestUrl = apiUrl.getBankAccountDetailsData

        mocks.mockData(requestUrl, 2000, 'getBankAccountDetailsData')
        const response = await axiosInstance.get(requestUrl)

        context.commit('updateBankAccountDetailsData', response.data.data)

        return response
      },
      async postBankAccountDetails(context, payload) {
        const requestUrl = apiUrl.postBankAccountDetails
        mocks.mockPost(requestUrl, payload, mockdb.randomNumber(200, 2000), 'postBankAccountDetails')
        const response = await axiosInstance.post(requestUrl, payload)

        if (response.status === 200) context.commit('updateBankAccountDetailsData', response.data.data)
        //if (response.status !== 200) addNotification(context, response)

        return response
      },
      SET_toggleDeliverySiteSelector(context) {
        context.commit('toggleDeliverySiteSelectorDesktopOpen')
      },
      SET_toggleDeliverySiteSelectorMobileOpen(context) {
        context.commit('toggleDeliverySiteSelectorMobileOpen')
      },
      SET_closeDeliverySiteSelector(context) {
        context.commit('closeDeliverySiteSelector')
      },
      SET_closeDeliverySiteSelectorMobile(context) {
        context.commit('closeDeliverySiteSelectorMobile')
      },
      SET_addNotification(context, notification) {
        context.commit('pushNotification', notification)
      },
      SET_closeNotification(context, notification) {
        context.commit('closeNotification', notification)
      },
      SET_chartDirection(context, payload) {
        context.commit('setChartDirection', payload)
      }
    },
    mutations: {
      updateOptInOutInformation(state, payload) {
        state.optInOutInformation = [...payload]
      },
      updatePowerOutageNotificationsData(state, responseData) {
        state.powerOutageNotifications = responseData
      },
      toggleDeliverySiteSelectorDesktopOpen(state) {
        state.deliverySiteSelectorDesktopOpen = !state.deliverySiteSelectorDesktopOpen
      },
      toggleDeliverySiteSelectorMobileOpen(state) {
        state.deliverySiteSelectorMobileOpen = !state.deliverySiteSelectorMobileOpen
      },
      closeDeliverySiteSelector(state) {
        state.deliverySiteSelectorDesktopOpen = false
      },
      closeDeliverySiteSelectorMobile(state) {
        state.deliverySiteSelectorMobileOpen = false
      },
      updateDeliverySiteInformation(state, payload) {
        state.deliverySiteInformation = payload
      },
      updateOverviewInvoiceData(state, payload) {
        state.overviewInvoiceData = {
          items: payload.response.data?.items
        }
      },
      updateOverviewPowerOutageData(state, payload) {
        state.overviewPowerOutageData = {
          items: payload.response.data?.items
        }
      },
      updateConsumptionChartData(state, payload) {
        state.consumptionChartData = {
          ...state.consumptionChartData,
          [payload.type]: payload.response
        }
      },
      resetConsumptionChartData(state) {
        state.consumptionChartData = {}
      },
      updateMeterReadingsData(state, payload) {
        state.meterReadingsData = {
          totalItemsCount: payload.response.meta?.totalItemsCount ?? 0,
          items: payload.reset ? payload.response.data?.items : [...state.meterReadingsData.items, ...(payload.response.data?.items ?? [])]
        }
      },
      pushNotification(state, notification) {
        const notificationId = notification.id ?? (Math.random().toString(36) + Date.now().toString(36)).substring(2)
        state.notifications.push({
          ...notification,
          id: notificationId
        })
        return notificationId
      },
      closeNotification(state, notificationToRemove) {
        state.notifications = state.notifications.filter((notification) => {
          return notification.id != notificationToRemove.id
        })
      },
      updateInvoiceSettingsData(state, payload) {
        state.invoiceSettingsData = payload.response.data
      },
      updateInvoiceSendMethodData(state, payload) {
        state.invoiceSendMethodData = payload.response.data
      },
      updateAccountSettingsEmailData(state, payload) {
        state.accountSettingsEmailData = payload
      },
      resetMeterReadingsData(state) {
        state.meterReadingsData = {
          totalItemsCount: 5,
          items: []
        }
      },
      updateCustomerDetails(state, payload) {
        state.customerDetails = payload
      },
      updateContactDetails(state, payload) {
        state.contactDetails = payload
      },
      setChartDirection(state, payload) {
        state.chartDirection = payload
      },
      updateCreditPaymentsData(state, payload) {
        state.creditPaymentsTableData = {
          totalItemsCount: payload.response.meta?.totalItemsCount ?? 0,
          items: payload.reset ? payload.response.data?.items : [...state.creditPaymentsTableData.items, ...(payload.response?.data?.items ?? [])]
        }
      },
      updatePossiblePayoutsData(state, payload) {
        state.possiblePayouts = payload
      },
      updateBankAccountDetailsData(state, payload) {
        state.bankAccountDetails = payload
      }
    }
  }
}
